export default __webpack_public_path__ + "static/media/FICHA TÉCNICA - ABÓBORA SERGIPANA.0dbec751.pdf";